import React, { useContext } from 'react';
import { Box, SxProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function Dropbox({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: sp.s20,
        width: 1,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
